import { FrameContext } from '@farris/devkit';
import { AppParamUtil } from './app-param.util';

const IS_ADD = 'IS_ADD';
const LAST_MODIFIED_ID = 'LAST_MODIFIED_ID';

/**
 * è¡¨åç¶æå·¥å·ç±»
 * @internal
 */
class EditStateUtil {

    /**
     * è·åå½åè¡id
     */
    public static getLastModifiedId(frameContext: FrameContext): string {
        // const lastModifiedId = AppParamUtil.get(frameContext, LAST_MODIFIED_ID);
        const virtualRootFrameContext = frameContext.getVirtualRootFrameContext();
        let lastModifiedId = null;
        if (virtualRootFrameContext) {
            lastModifiedId = virtualRootFrameContext.getParam(LAST_MODIFIED_ID);
            return lastModifiedId ? lastModifiedId : null;
        }
        return lastModifiedId;
    }

    /**
     * è®¾ç½®æåä¿®æ¹çid
     */
    public static setLastModifiedId(frameContext: FrameContext, lastModifiedId: string): void {
        // AppParamUtil.set(frameContext, LAST_MODIFIED_ID, lastModifiedId);
        const virtualRootFrameContext = frameContext.getVirtualRootFrameContext();
        if (virtualRootFrameContext) {
            virtualRootFrameContext.setParam(LAST_MODIFIED_ID, lastModifiedId);
        }
    }

    /**
     * è·åæ°å¢ç¶æ
     */
    public static getAddState(frameContext: FrameContext, ): boolean {
        // return AppParamUtil.get(frameContext, IS_ADD);
        const virtualRootFrameContext = frameContext.getVirtualRootFrameContext();
        if (virtualRootFrameContext) {
            return virtualRootFrameContext.getParam(IS_ADD);
        }
    }

    /**
     * è®¾ç½®æ°å¢ç¶æ
     */
    public static setAddState(frameContext: FrameContext, lastModifiedId: string): void {
        // AppParamUtil.set(frameContext, IS_ADD, true);
        const virtualRootFrameContext = frameContext.getVirtualRootFrameContext();
        if (virtualRootFrameContext) {
            virtualRootFrameContext.setParam(IS_ADD, true);
        }
        this.setLastModifiedId(frameContext, lastModifiedId);
    }

    /**
     * åæ¶æ°å¢ç¶æ
     */
    public static cancelAddState(frameContext: FrameContext) {
        // AppParamUtil.set(frameContext, IS_ADD, false);
        const virtualRootFrameContext = frameContext.getVirtualRootFrameContext();
        if (virtualRootFrameContext) {
            virtualRootFrameContext.setParam(IS_ADD, false);
        }
    }

    /**
     * è®¾ç½®ç¼è¾ç¶æ
     */
    public static setEditState(frameContext: FrameContext, id: string) {
        // AppParamUtil.set(frameContext, IS_ADD, false);
        const virtualRootFrameContext = frameContext.getVirtualRootFrameContext();
        if (virtualRootFrameContext) {
            virtualRootFrameContext.setParam(IS_ADD, false);
        }
        this.setLastModifiedId(frameContext, id);
    }
}

export { EditStateUtil };
